"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SttButton = _interopRequireDefault(require("./SttButton/SttButton"));
var _SttHeading = _interopRequireDefault(require("./SttTypography/SttHeading"));
var _SttModal = _interopRequireDefault(require("./SttModal"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function SttSplashScreen(props) {
  var modulo = props.modulo,
    versao = props.versao,
    novidades = props.novidades,
    textoAjuda = props.textoAjuda,
    open = props.open,
    setOpen = props.setOpen,
    perfisRBAC = props.perfisRBAC;
  function handleCloseModal() {
    setOpen(false);
  }
  (0, _react.useEffect)(function () {
    if (!perfisRBAC || perfisRBAC.length === 0) return;
    if (!perfisRBAC.some(function (p) {
      return p.identificador === 'administrador';
    })) return;
    var moduloVersao = "stt-".concat(modulo, "-").concat(versao);
    var storageLS = localStorage.getItem(moduloVersao);
    var storageCookie = _jsCookie["default"].get(moduloVersao);
    if (!storageLS && !storageCookie) {
      localStorage.setItem(moduloVersao, true);
      _jsCookie["default"].set(moduloVersao, 'true');
      setOpen(true);
    }
    ;
  }, [perfisRBAC]);
  return /*#__PURE__*/_react["default"].createElement(_SttModal["default"], {
    title: "Notas de atualiza\xE7\xE3o",
    open: open,
    outModalClose: handleCloseModal,
    maxWidth: "lg",
    fullWidth: true,
    iconClose: handleCloseModal,
    children: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
      variant: "h2",
      color: "primary"
    }, "STT 2 - M\xF3dulo \"", modulo, "\" vers\xE3o ", versao), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
      variant: "h3",
      color: "primary"
    }, "Novidades:"), novidades && novidades.length > 0 && novidades.map(function (n, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: index
      }, /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
        variant: "h5",
        color: "initial"
      }, "- ", n));
    }), textoAjuda && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_SttHeading["default"], {
      variant: "h4",
      color: "initial"
    }, textoAjuda))),
    footer: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_SttButton["default"], {
      variant: "contained",
      color: "primary",
      onClick: handleCloseModal
    }, "Fechar"))
  });
}
SttSplashScreen.propTypes = {
  modulo: _propTypes["default"].string,
  versao: _propTypes["default"].string,
  novidades: _propTypes["default"].array
};
var _default = SttSplashScreen;
exports["default"] = _default;